var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerHub',{staticClass:"hub-contacts-groups"},[_c('template',{slot:"header"},[_c('HubHeader',{attrs:{"titleTag":'h1',"title":_vm.title,"email":_vm.email,"description":_vm.description}})],1),_c('template',{slot:"body"},_vm._l((_vm.items),function(item,index){return _c('GroupTeams',{key:`group-${index}`,attrs:{"content":item}})}),1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }